

// import React, { useEffect, useState } from "react";
// import {
//   getAllCompanyCategories,
//   createCompanyCategory,
//   updateCompanyCategory,
//   deleteCompanyCategory,
// } from "../../../services/adminService";
// import {
//   Button,
//   Table,
//   Form,
//   Modal,
//   Spinner,
//   Alert,
//   Badge,
// } from "react-bootstrap";

// const CompanyCategory = () => {
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [showModal, setShowModal] = useState(false);
//   const [editCategory, setEditCategory] = useState(null);
//   const [formData, setFormData] = useState({ name: "", type: "service", image: null });

//   // Fetch categories
//   const fetchCategories = async () => {
//     try {
//       setLoading(true);
//       const res = await getAllCompanyCategories();
//       let data = res.data || [];
//       data.sort((a, b) => {
//         if (a.type === b.type) return a.name.localeCompare(b.name);
//         return a.type === "service" ? -1 : 1;
//       });
//       setCategories(data);
//       setLoading(false);
//     } catch (err) {
//       setError("Failed to fetch categories");
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   // Handle input changes
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   // Handle image selection
//   const handleImageChange = (e) => {
//     if (e.target.files && e.target.files[0]) {
//       setFormData({ ...formData, image: e.target.files[0] });
//     }
//   };

//   // Save category (create/update)
//   const handleSave = async () => {
//     try {
//       const payload = new FormData();
//       payload.append("name", formData.name);
//       payload.append("type", formData.type);
//       if (formData.image) payload.append("image", formData.image); // match backend key

//       if (editCategory) {
//         await updateCompanyCategory(editCategory._id, payload);
//       } else {
//         await createCompanyCategory(payload);
//       }

//       setShowModal(false);
//       setFormData({ name: "", type: "service", image: null });
//       setEditCategory(null);
//       fetchCategories();
//     } catch (err) {
//       setError("Failed to save category");
//     }
//   };

//   // Delete category
//   const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this category?")) {
//       try {
//         await deleteCompanyCategory(id);
//         setCategories((prev) => prev.filter((c) => c._id !== id));
//       } catch (err) {
//         setError("Failed to delete category");
//       }
//     }
//   };

//   // Edit category
//   const handleEdit = (category) => {
//     setEditCategory(category);
//     setFormData({ name: category.name, type: category.type, image: null });
//     setShowModal(true);
//   };

//   return (
//     <div className="container mt-4">
//       <h2 className="mb-3 text-center fw-bold">🏷 Company Categories</h2>

//       {error && <Alert variant="danger">{error}</Alert>}

//       <div className="d-flex justify-content-end mb-3">
//         <Button variant="primary" onClick={() => setShowModal(true)}>
//           + Add New Category
//         </Button>
//       </div>

//       {loading ? (
//         <div className="text-center">
//           <Spinner animation="border" />
//         </div>
//       ) : (
//         <Table striped bordered hover responsive className="align-middle text-center shadow-sm">
//           <thead className="table-dark">
//             <tr>
//               <th>#</th>
//               <th>Image</th>
//               <th>Name</th>
//               <th>Type</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {categories.length > 0 ? (
//               categories.map((cat, index) => (
//                 <tr key={cat._id}>
//                   <td>{index + 1}</td>
//                   <td>
//                     {cat.image ? (
//                       <img
//                         src={cat.image}
//                         alt={cat.name}
//                         style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "4px" }}
//                       />
//                     ) : (
//                       "—"
//                     )}
//                   </td>
//                   <td className="fw-semibold">{cat.name}</td>
//                   <td>
//                     <Badge bg={cat.type === "service" ? "info" : "success"}>{cat.type}</Badge>
//                   </td>
//                   <td>
//                     <Button variant="warning" size="sm" className="me-2" onClick={() => handleEdit(cat)}>
//                       ✏️ Edit
//                     </Button>
//                     <Button variant="danger" size="sm" onClick={() => handleDelete(cat._id)}>
//                       🗑 Delete
//                     </Button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="5" className="text-center text-muted">
//                   No categories found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </Table>
//       )}

//       {/* Add/Edit Modal */}
//       <Modal show={showModal} onHide={() => setShowModal(false)} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>{editCategory ? "Edit Category" : "Add Category"}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group controlId="categoryName" className="mb-3">
//               <Form.Label>Name</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 placeholder="Enter category name"
//               />
//             </Form.Group>

//             <Form.Group controlId="categoryType" className="mb-3">
//               <Form.Label>Type</Form.Label>
//               <Form.Select name="type" value={formData.type} onChange={handleChange}>
//                 <option value="service">Service</option>
//                 <option value="product">Product</option>
//               </Form.Select>
//             </Form.Group>

//             <Form.Group controlId="categoryImage" className="mb-3">
//               <Form.Label>Image</Form.Label>
//               <Form.Control type="file" accept="image/*" onChange={handleImageChange} />
//               {editCategory && editCategory.image && !formData.image && (
//                 <div className="mt-2">
//                   <img
//                     src={editCategory.image}
//                     alt={editCategory.name}
//                     style={{ width: "80px", height: "80px", objectFit: "cover", borderRadius: "4px" }}
//                   />
//                 </div>
//               )}
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowModal(false)}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleSave}>
//             {editCategory ? "Update" : "Save"}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default CompanyCategory;
// src/components/admin/CompanyCategory.jsx

import React, { useEffect, useState } from "react";
import {
  getAllCompanyCategories,
  createCompanyCategory,
  updateCompanyCategory,
  deleteCompanyCategory,
} from "../../../services/adminService"; // Adjust path as needed
import {
  Button,
  Table,
  Form,
  Modal,
  Spinner,
  Alert,
  Badge,
} from "react-bootstrap";
// Import the new management component
import CategoryCompanyManagement from "./CategoryCompanyManagement"; // Adjust path as needed

const CompanyCategory = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editCategory, setEditCategory] = useState(null);
  const [formData, setFormData] = useState({ name: "", type: "service", image: null });

  // NEW STATE: To control which category's companies are being managed
  const [selectedCategoryForManagement, setSelectedCategoryForManagement] = useState(null);

  // Fetch categories
  const fetchCategories = async () => {
    try {
      setLoading(true);
      const res = await getAllCompanyCategories();
      // FIX: Access `res.data.data` if your backend wraps the array in a 'data' field
      // If your backend directly returns the array, use `res.data`
      let data = res.data.data || res.data || [];
      
      data.sort((a, b) => {
        if (a.type === b.type) return a.name.localeCompare(b.name);
        return a.type === "service" ? -1 : 1;
      });
      setCategories(data);
      setLoading(false);
    } catch (err) {
      setError("Failed to fetch categories: " + (err.response?.data?.message || err.message));
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle image selection
  const handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFormData({ ...formData, image: e.target.files[0] });
    }
  };

  // Save category (create/update)
  const handleSave = async () => {
    try {
      const payload = new FormData();
      payload.append("name", formData.name);
      payload.append("type", formData.type);
      if (formData.image) payload.append("image", formData.image);

      if (editCategory) {
        await updateCompanyCategory(editCategory._id, payload);
      } else {
        await createCompanyCategory(payload);
      }

      setShowModal(false);
      setFormData({ name: "", type: "service", image: null });
      setEditCategory(null);
      fetchCategories(); // Re-fetch categories to update the list
    } catch (err) {
      setError("Failed to save category");
    }
  };

  // Delete category
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this category? This will also delete its subcategories.")) {
      try {
        await deleteCompanyCategory(id);
        setCategories((prev) => prev.filter((c) => c._id !== id));
      } catch (err) {
        setError("Failed to delete category: " + (err.response?.data?.message || err.message));
      }
    }
  };

  // Edit category
  const handleEdit = (category) => {
    setEditCategory(category);
    setFormData({ name: category.name, type: category.type, image: null });
    setShowModal(true);
  };

  // Function to navigate to the company management page for a specific category
  const handleManageCompanies = (category) => {
    setSelectedCategoryForManagement(category);
  };

  // Function to go back to the category list view from company management
  const handleBackToCategories = () => {
    setSelectedCategoryForManagement(null);
    fetchCategories(); // Optionally re-fetch categories on back to ensure fresh data
  };

  // Conditional rendering: If a category is selected for managing companies, show that component
  if (selectedCategoryForManagement) {
    return (
      <CategoryCompanyManagement
        categoryId={selectedCategoryForManagement._id}
        categoryName={selectedCategoryForManagement.name}
        onBack={handleBackToCategories}
      />
    );
  }

  // Otherwise, show the category management table
  return (
    <div className="container mt-4">
      <h2 className="mb-3 text-center fw-bold">🏷 Company Categories</h2>

      {error && <Alert variant="danger">{error}</Alert>}

      <div className="d-flex justify-content-end mb-3">
        <Button variant="primary" onClick={() => { setShowModal(true); setEditCategory(null); setFormData({ name: "", type: "service", image: null }); }}>
          + Add New Category
        </Button>
      </div>

      {loading ? (
        <div className="text-center">
          <Spinner animation="border" />
        </div>
      ) : (
        <Table striped bordered hover responsive className="align-middle text-center shadow-sm">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>Image</th>
              <th>Name</th>
              <th>Type</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {categories.length > 0 ? (
              categories.map((cat, index) => (
                <tr key={cat._id}>
                  <td>{index + 1}</td>
                  <td>
                    {cat.image ? (
                      <img
                        src={cat.image}
                        alt={cat.name}
                        style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "4px" }}
                      />
                    ) : (
                      "—"
                    )}
                  </td>
                  <td className="fw-semibold">{cat.name}</td>
                  <td>
                    <Badge bg={cat.type === "service" ? "info" : "success"}>{cat.type}</Badge>
                  </td>
                  <td>
                    <Button variant="info" size="sm" className="me-2" onClick={() => handleManageCompanies(cat)}>
                      Manage Companies
                    </Button>
                    <Button variant="warning" size="sm" className="me-2" onClick={() => handleEdit(cat)}>
                      ✏️ Edit Category
                    </Button>
                    <Button variant="danger" size="sm" onClick={() => handleDelete(cat._id)}>
                      🗑 Delete Category
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center text-muted">
                  No categories found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      )}

      {/* Add/Edit Category Modal - This part remains for category specific operations */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{editCategory ? "Edit Category" : "Add Category"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="categoryName" className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter category name"
              />
            </Form.Group>

            <Form.Group controlId="categoryType" className="mb-3">
              <Form.Label>Type</Form.Label>
              <Form.Select name="type" value={formData.type} onChange={handleChange}>
                <option value="service">Service</option>
                <option value="product">Product</option>
              </Form.Select>
            </Form.Group>

            <Form.Group controlId="categoryImage" className="mb-3">
              <Form.Label>Image</Form.Label>
              <Form.Control type="file" accept="image/*" onChange={handleImageChange} />
              {editCategory && editCategory.image && !formData.image && (
                <div className="mt-2">
                  <img
                    src={editCategory.image}
                    alt={editCategory.name}
                    style={{ width: "80px", height: "80px", objectFit: "cover", borderRadius: "4px" }}
                  />
                </div>
              )}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSave}>
            {editCategory ? "Update" : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CompanyCategory;